An array of further divisions of the country.

These may include districts, regions, states, provinces, etc.
